import { render } from "./TeItiKahurangiForm.vue?vue&type=template&id=5cb1a0e4"
import script from "./TeItiKahurangiForm.vue?vue&type=script&lang=js"
export * from "./TeItiKahurangiForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__